import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAnnualToggle,
  setAnnualFlag,
  getSubscription,
  getSelectedPlanValue,
  getPaymentRouteType,
  fetchProratedCharge,
  getUpdatePaymentSettingsFlag,
} from 'ducks/trialWarning'

import { PlanChangeContext } from 'components/Shared/TrialWarning/PlanChangeContext'
import OrderSummary from './OrderSummary'
import CouponSection from './CouponSection'
import useCouponManagement from './hooks/useCouponManagement'
import { PaymentMethodForm } from './PaymentMethodForm'

export const PaymentForm = props => {
  const { additionalPublishedApps, additionalTeamMembers } =
    useContext(PlanChangeContext)

  const { hideCoupon, planName, submitting, organizationId } = props

  const dispatch = useDispatch()

  const annual = useSelector(getAnnualToggle)
  const isPaymentMethodUpdateOnly = useSelector(getUpdatePaymentSettingsFlag)
  const paymentRouteType = useSelector(getPaymentRouteType)
  const selectedPlanValue = useSelector(getSelectedPlanValue)
  const subscription = useSelector(getSubscription) || {}

  const {
    coupon,
    couponError,
    couponVisible,
    couponSuccess,
    isRegionalDiscount,
    showCoupon,
    getCoupon,
  } = useCouponManagement({
    organizationId,
    selectedPlanValue,
    annual,
    additionalPublishedApps,
    additionalTeamMembers,
  })

  const onToggle = () => {
    dispatch(
      fetchProratedCharge(
        organizationId,
        selectedPlanValue,
        !annual,
        coupon?.id,
        additionalPublishedApps,
        additionalTeamMembers
      )
    )
    dispatch(setAnnualFlag(!annual))
  }

  const { planType } = subscription

  const renderSwitchToYearly =
    (paymentRouteType === 'upgrade' || (!selectedPlanValue && !hideCoupon)) &&
    (!selectedPlanValue || selectedPlanValue !== planType)

  const renderCoupon = () => (
    <CouponSection
      couponVisible={couponVisible}
      couponSuccess={couponSuccess}
      couponError={couponError}
      isRegionalDiscount={isRegionalDiscount}
      showCoupon={showCoupon}
      getCoupon={getCoupon}
      hideCoupon={hideCoupon}
    />
  )

  return (
    <>
      {!isPaymentMethodUpdateOnly && (
        <OrderSummary
          planName={planName}
          coupon={coupon}
          submitting={submitting}
          onToggle={onToggle}
          renderCoupon={renderCoupon}
          showSwitchToYearly={renderSwitchToYearly}
          isRegionalDiscount={isRegionalDiscount}
        />
      )}
      <PaymentMethodForm
        selectedPlanValue={selectedPlanValue}
        subscription={subscription}
      />
    </>
  )
}
